import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { useEffect, useMemo, useState } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { useDispatch } from 'react-redux';
import sleep from 'sleep-promise';

function List() {

    const profileFilter = chooseProfileFilter(); 
    const pathFrontEnd = '/governanceroom/socialsectors/';
    const paths = { 
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}governanceroom/socialsectors/delete`,
        endpointCities: `${config.endpoints.backend}governanceroom/cities/getall`,
        endpoint: `${config.endpoints.backend}governanceroom/socialsectors/getall`
    }

    const dispatch = useDispatch();
    const [filterValues, setFilterValues] = useState({});

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = {...filterValues}
        filters = {...filters, [target['name']]: target['value']}
        setFilterValues(filters)
        await sleep(1000);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    };

    useEffect(() => {
        async function fetchsocialsectors (){
            await sleep(500);
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        }

        fetchsocialsectors();
    }, [filterValues]);

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.governance_room_geo_city_id}`,
        handleSubmit: loadData,
        fields: [
            {
                name: 'governance_room_geo_city_id',
                type: 'select',
                label: 'Município',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointCities,
                    label: 'city_name',
                    value: 'id',
                    params: {
                        filter: {
                            where: {
                                profileFilter
                            }
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
        ],
        values: {
            governance_room_geo_city_id: filterValues.governance_room_geo_city_id,

        }
    }), [filterValues]);
    
    const list = useMemo(() => {

        let list = { 
            labelTitle: 'Setores Sociais',
            labelTitleButtonAdd: 'Novo Setor Social',
            showPrintButtons: false,
            fieldsShowOnDelete: ['description', 'city_state_name'],
            filter:{
                governance_room_geo_city_id: filterValues.governance_room_geo_city_id,
                profileFilter
            },
            formFilters: filters,
            columns: [
                {
                    name: 'city_state_name',
                    label: 'Cidade',
                    width: '25%'
                },
                {
                    name: 'description',
                    label: 'Setor',
                    width: '25%'
                },
            ],
        }

        list = {...paths, ...list};
        return list;
        
    }, [filterValues]);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list, filters]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, filters, list]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;